import React, { useEffect } from 'react';
import {Box, Container, Grid} from '@material-ui/core';
import {MetaTags} from 'react-meta-tags';
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';
import Cookies from 'js-cookie';
import axios from 'axios';
import {API_URL} from '../utils/EnvVars';


  export default function Execute() {
	var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));

	useEffect(() => {
		if(etlStudentObj && etlStudentObj.token){
			///removeToken();
			removeAndRedirect();
		}else{
			removeAndRedirect();				
		}
	}, [])

	function removeToken(){
		if(etlStudentObj && etlStudentObj.token){
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
				}
			};		  
			const data = new FormData();
			data.append('token', etlStudentObj.token);
			axios.post(API_URL+'/student-remove-token', data, axiosHeader)
			.then((response) => {
				removeAndRedirect();				
			})
			.catch((error) => {
				///console.log("AXIOS ERROR: ", error);
			})

		}	
	}

	function removeAndRedirect(){
		Cookies.remove("accountDetails")
		Cookies.remove("token")
		Cookies.remove("courseDetails")		
		window.localStorage.removeItem('etlStudentObj');
		window.localStorage.removeItem("templateId");
		window.localStorage.removeItem("cacheDate");
		window.localStorage.removeItem("etlSelectCourse");
		window.localStorage.removeItem("etlMyCourses");
		////window.localStorage.clear(); 
		window.location.href='login';
	}


		return (
			<div> 
				<MetaTags>
            		<title>Logout - Smart E-Learning Platform </title>
            		<meta name="description" content="Logout" />
          		</MetaTags>
				
				<Container className="loginBGImg" style={{backgroundImage:"url('/student_login_bg.jpg')"}}>					

				<Box>
						<Grid container style={{justifyContent: 'center'}} spacing={2}>
							<Grid item className="dhslogin" md={6} xs={12}>

							
								<Grid className="flex-container loginbox">								
									
									<h2 style={{color:'#FFF',marginTop:'16%'}}>Please wait...</h2>
								
								</Grid>
							

							</Grid>
											

						</Grid>
				</Box>




				</Container>
				
			</div>
		);
 
}